import { buildFullUrls } from "../shared/utils/buildUrl";

/** Test/MSW host — services stay relative; server-call prepends VITE_BASE_URL. */
export const BASE_URL = "http://localhost:5268/api/v1";

const AUTH_BASE = "/auth";
const PROFILE_BASE = "/profile";
const SURVEY_INBOX_BASE = "/survey-inbox";
const USER_PERMISSION_BASE = "/user-permission";
const USER_RESPONSES_BASE = "/user-responses";
const BRAND_BASE = "/brand";
const GROUP_BASE = "/group";
const STORE_BASE = "/store";
const MANAGER_BASE = "/manager";
const FEATURE_BASE = "/feature";
const SURVEY_BASE = "/survey";
const CUSTOMER_BASE = "/customer";
const EMAIL_BASE = "/email";
const ACTIVITY_BASE = "/activity";
const API_KEY_BASE = "/api-key";
const CAMPAIGN_METRICS_BASE = "/campaign-matric";
const MARKETING_EXTENDED_REPORT_BASE = "/marketing-extended-report";
const MARKETING_SALES_REPORT_BASE = "/marketing-sales-report";
const RESTAURANT_THEME_BASE = "/restaurant-theme";
const STORE_MERGING_LOG_BASE = "/store-merging-log";
const REQUEST_HELP_BASE = "/request-help";
const AZURE_AI_BASE = "/customer-conversation-azure-ai";
const MARKETING_ATTRIBUTION_BASE = "/marketing-attribution";

/** Relative paths for services (server-call adds VITE_BASE_URL). */
export const API_URLS = {
  AUTH: {
    BASE: AUTH_BASE,
    FORGOT_PASSWORD: `${AUTH_BASE}/forgot-password`,
    RESET_PASSWORD: `${AUTH_BASE}/reset-password`,
    VERIFY_EMAIL: `${AUTH_BASE}/verify-email`,
    CONSUMER_NAVIGATION: `${AUTH_BASE}/consumer-navigation`,
  },
  PROFILE: {
    BASE: PROFILE_BASE,
    GET: `${PROFILE_BASE}/get`,
    CHANGE_PASSWORD: `${PROFILE_BASE}/change-password`,
    DELETE_PROFILE_IMAGE: `${PROFILE_BASE}/delete-profile-image`,
    RESEND_CREATE_PASSWORD_EMAIL: `${PROFILE_BASE}/resend-create-password-email`,
    UPDATE_PROFILE_PIC: `${PROFILE_BASE}/update-profile-pic`,
    GET_USER_BY_ID: `${PROFILE_BASE}/get-user-by-id`,
    UPDATE_USER_CLARITY_CONSENT: `${PROFILE_BASE}/update-user-clarity-consent`,
    UPDATE: `${PROFILE_BASE}/update`,
  },
  SURVEY_INBOX: {
    BASE: SURVEY_INBOX_BASE,
    GET_PREVIOUS_CONVERSATION_DATES: `${SURVEY_INBOX_BASE}/get-previous-conversation-dates`,
    GET_CONVERSATION_MESSAGES: `${SURVEY_INBOX_BASE}/get-conversation-messages`,
    UPDATE_CUSTOMER_CONVERSATION_MESSAGES: `${SURVEY_INBOX_BASE}/update-customer-conversation-messages`,
    SAVE_INTERNAL_NOTES_FOR_THE_CONVERSATION: `${SURVEY_INBOX_BASE}/save-internal-notes-for-the-conversation`,
    PREVIEW_CUSTOMER_SURVEY: `${SURVEY_INBOX_BASE}/preview-customer-survey`,
    GET_CONVERSATION_INTERNAL_NOTES: `${SURVEY_INBOX_BASE}/get-conversation-internal-notes`,
    GET_CUSTOMER_INSIGHTS: `${SURVEY_INBOX_BASE}/get-customer-insights`,
    GET_CONVERSATION: `${SURVEY_INBOX_BASE}/get-conversation`,
    GET_CONVERSATION_ORDER_DETAILS: `${SURVEY_INBOX_BASE}/get-conversation-order-details`,
    GET_ALL_CUSTOMER_CONVERSATION_NOTES: `${SURVEY_INBOX_BASE}/get-all-customer-conversation-notes`,
    GET_INBOX_CONVERSATION_DATA: `${SURVEY_INBOX_BASE}/get-inbox-conversation-data`,
    GET_INBOX_CONVERSATION_DATA_FOR_STORE: `${SURVEY_INBOX_BASE}/get-inbox-conversation-data-for-store`,
    GET_INBOX_CONVERSATION_SUMMARY: `${SURVEY_INBOX_BASE}/get-inbox-conversation-summary`,
    GET_SURVEY_USERS: `${SURVEY_INBOX_BASE}/GetSurveyUsers`,
  },
  USER_PERMISSION: {
    BASE: USER_PERMISSION_BASE,
    GET_USER_PERMISSION: `${USER_PERMISSION_BASE}/get-user-permission`,
    GET_USER_PERMISSION_FOR_GROUP: `${USER_PERMISSION_BASE}/get-user-permission-for-group`,
    GET_USER_PERMISSION_FOR_MANAGER: `${USER_PERMISSION_BASE}/get-user-permission-for-manager`,
  },
  USER_RESPONSES: {
    BASE: USER_RESPONSES_BASE,
    GET_ALL_USER_RESPONSES: `${USER_RESPONSES_BASE}/get-all-user-responses`,
    GET_ALL_USER_RESPONSES_FR_ROUTE: `${USER_RESPONSES_BASE}/get-all-user-responses/fr-route`,
    GET_ORDER_DETAILS: `${USER_RESPONSES_BASE}/get-order-details`,
    GET_BRAND_RESPONSES: `${USER_RESPONSES_BASE}/get-brand-responses`,
    GET_BRAND_SURVEY_CONVERSION_RATE_KPI: `${USER_RESPONSES_BASE}/get-brand-survey-conversion-rate-kpi`,
    GET_SURVEY_CONVERSION_RATE_KPI_SUMMARY: `${USER_RESPONSES_BASE}/get-survey-conversion-rate-kpi-summary`,
    GET_AVERAGE_RATING_RESPONSES: `${USER_RESPONSES_BASE}/get-average-rating-responses`,
    GET_RECORD_PAGINATION_RESPONSES: `${USER_RESPONSES_BASE}/get-record-pagination-responses`,
    EXPORT_BRAND_SURVEY_RESPONSES: `${USER_RESPONSES_BASE}/export-brand-survey-responses`,
    GET_SURVEY_REPORT_FOR_POS_AND_ONLINE_STORES: `${USER_RESPONSES_BASE}/get-survey-report-for-pos-and-online-stores`,
    GET_STORE_AVERAGE_RATING_RESPONSES: `${USER_RESPONSES_BASE}/get-store-average-rating-responses`,
    GET_GROUP_USER_RESPONSES: `${USER_RESPONSES_BASE}/get/group-user/get-group-responses`,
    GET_RESTAURANT_RESPONSES: `${USER_RESPONSES_BASE}/get-restaurant-responses`,
    GET_GROUP_RESPONSES: `${USER_RESPONSES_BASE}/get/get-group-responses`,
    GET_GROUPS_AVERAGE_RATING_RESPONSES: `${USER_RESPONSES_BASE}/get-groups-average-rating-responses`,
    GET_GROUP_AVERAGE_RATING_RESPONSES: `${USER_RESPONSES_BASE}/get-group/get-group-average-rating-responses`,
    GET_MANAGER_RESPONSES: `${USER_RESPONSES_BASE}/get/manager-user/get-manager-responses`,
    GET_MANAGER_AVERAGE_RATING_RESPONSES: `${USER_RESPONSES_BASE}/get-manager-average-rating-responses`,
    GET_INDIVIDUAL_STORE_AVERAGE_RATING_RESPONSES: `${USER_RESPONSES_BASE}/get-individual-store-average-rating-responses`,
    STORE: `${USER_RESPONSES_BASE}/store`,
  },
  BRAND: {
    BASE: BRAND_BASE,
    STORES: `${BRAND_BASE}/stores`,
    BRAND_PROFILE: `${BRAND_BASE}/brand-profile`,
    GET_STORE: `${BRAND_BASE}/get-store`,
    GET_ALL_BRANDS: `${BRAND_BASE}/get-all-brands`,
    GET_ALL_STORES_BY_BRAND_ID: `${BRAND_BASE}/get-all-stores-by-brand-id`,
    GET_LOCATION_BY_BRAND_ID: `${BRAND_BASE}/get-location-by-brand-id`,
    GET_BRAND_DETAIL: `${BRAND_BASE}/get-brand-detail`,
    GET_BRAND_SOCIAL_LINKS: `${BRAND_BASE}/get-brand-social-links`,
    UPDATE_BRAND_SOCIAL_LINKS: `${BRAND_BASE}/update-brand-social-links`,
    GET_ALL_BRANDS_FOR_AI_REPLY: `${BRAND_BASE}/get-all-brands-for-ai-reply`,
    UPDATE_BRAND_STATUS: `${BRAND_BASE}/update-brand-status`,
  },
  GROUP: {
    BASE: GROUP_BASE,
    GET: `${GROUP_BASE}/get`,
    UPDATE_GROUP: `${GROUP_BASE}/update-group`,
    REMOVE_LOCATION: `${GROUP_BASE}/remove-location`,
    UPDATE_GROUP_STATUS: `${GROUP_BASE}/get-groups/update-group-status`,
    GROUP_PROFILE: `${GROUP_BASE}/get/group-profile`,
    STORES: `${GROUP_BASE}/stores`,
    PAGINATED_GROUP_PROFILE: `${GROUP_BASE}/paginated-group-profile`,
  },
  STORE: {
    BASE: STORE_BASE,
    GET: `${STORE_BASE}/get`,
    UPDATE: `${STORE_BASE}/update`,
    GET_STORES: `${STORE_BASE}/get-stores`,
    GET_STORES_BY_GROUP_ID: `${STORE_BASE}/get-stores-by-group-id`,
    GET_STORES_BY_GROUP_IDS: `${STORE_BASE}/get-stores-by-group-ids`,
    REPLACE_STORE: `${STORE_BASE}/replace-store`,
    UPDATE_STORE_STATUS: `${STORE_BASE}/update-store-status`,
  },
  MANAGER: {
    BASE: MANAGER_BASE,
    GET: `${MANAGER_BASE}/get`,
    GET_MANAGERS_BY_BRAND_ID: `${MANAGER_BASE}/get/get-managers-by-brand-id`,
    GET_MANAGERS_BY_GROUP_ID: `${MANAGER_BASE}/get/get-managers-by-group-id`,
    GET_MANAGERS_BY_ID: `${MANAGER_BASE}/get/get-managers-by-id`,
    GET_ALL_STORES_BY_MANAGER_ID: `${MANAGER_BASE}/get/get-all-stores-by-manager-id`,
    GET_STORES: `${MANAGER_BASE}/get/stores`,
    UPDATE_MANAGER: `${MANAGER_BASE}/update-manager`,
    REMOVE_LOCATION: `${MANAGER_BASE}/remove-location`,
    UPDATE_MANAGER_STATUS: `${MANAGER_BASE}/UpdateManagerStatus`,
  },
  FEATURE: {
    BASE: FEATURE_BASE,
    BRAND: `${FEATURE_BASE}/brand`,
    UPDATE_STORE_FEATURES: `${FEATURE_BASE}/update-store-features`,
  },
  AZURE_AI: {
    BASE: AZURE_AI_BASE,
    GENERATE_RESPONSE: `${AZURE_AI_BASE}/generate-response`,
    UPDATE_RESPONSE: `${AZURE_AI_BASE}/update-response`,
  },
  SURVEY: {
    BASE: SURVEY_BASE,
    GET_SURVEY_RECIPIENTS: `${SURVEY_BASE}/get-survey-recipients`,
    CUSTOMER: `${SURVEY_BASE}/customer`,
    LOG: `${SURVEY_BASE}/log`,
    ARCHIVED_QUESTIONS: `${SURVEY_BASE}/archived-questions`,
    REACTIVATE_ARCHIVED_QUESTION: `${SURVEY_BASE}/reactivate-archived-question`,
    USER_NOTIFICATION_PREFERENCES: `${SURVEY_BASE}/user-notification-preferences`,
    UPDATE_SURVEY_RECIPIENTS: `${SURVEY_BASE}/update-survey-recipients`,
  },
  CUSTOMER: {
    BASE: CUSTOMER_BASE,
    SURVEY_RESPONSE: `${CUSTOMER_BASE}/survey-response`,
    ADD_CUSTOMER_INVALID_ORDER_INFORMATION: `${CUSTOMER_BASE}/add-customer-invalid-order-information`,
    IMPORT_ORDERS_FROM_FR: `${CUSTOMER_BASE}/import-orders-from-fr`,
    SINGLE_EMAIL_URL: `${CUSTOMER_BASE}/single-email-url`,
  },
  EMAIL: {
    BASE: EMAIL_BASE,
    SEND_EMAIL_MESSAGE: `${EMAIL_BASE}/send-email-message`,
  },
  ACTIVITY: {
    BASE: ACTIVITY_BASE,
    ACTIVITY_LOG: `${ACTIVITY_BASE}/activity-log`,
  },
  API_KEY: {
    BASE: API_KEY_BASE,
    ALL: `${API_KEY_BASE}/all`,
    GENERATE: `${API_KEY_BASE}/generate`,
  },
  CAMPAIGN_METRICS: {
    BASE: CAMPAIGN_METRICS_BASE,
  },
  MARKETING_EXTENDED_REPORT: {
    BASE: MARKETING_EXTENDED_REPORT_BASE,
    GRAPH_DATA: `${MARKETING_EXTENDED_REPORT_BASE}/graph-data`,
    PAGINATED_DATA: `${MARKETING_EXTENDED_REPORT_BASE}/paginated-data`,
    GET_DELIVERY_BODY: `${MARKETING_EXTENDED_REPORT_BASE}/get-delivery-body`,
    PREPROCESSED_GRAPH_DATA: `${MARKETING_EXTENDED_REPORT_BASE}/preprocessed-graph-data`,
    PREPROCESSED_PAGINATED_DATA: `${MARKETING_EXTENDED_REPORT_BASE}/preprocessed-paginated-data`,
  },
  MARKETING_SALES_REPORT: {
    BASE: MARKETING_SALES_REPORT_BASE,
    CAMPAIGN_METRICS_PAGINATED_DATA: `${MARKETING_SALES_REPORT_BASE}/campaign-matric-paginated-data`,
    MARKETING_SALES_DATA: `${MARKETING_SALES_REPORT_BASE}/marketing-sales-data`,
    TOTAL_EMAILS_AND_SMS_DELIEVERED_COUNT: `${MARKETING_SALES_REPORT_BASE}/total-emails-and-sms-delievered-count`,
  },
  RESTAURANT_THEME: {
    BASE: RESTAURANT_THEME_BASE,
    GET: `${RESTAURANT_THEME_BASE}/get`,
    GET_THEME: `${RESTAURANT_THEME_BASE}/get-theme`,
    UPDATE: `${RESTAURANT_THEME_BASE}/update`,
    DELETE_LOGO: `${RESTAURANT_THEME_BASE}/delete-logo`,
  },
  STORE_MERGING_LOG: {
    BASE: STORE_MERGING_LOG_BASE,
  },
  REQUEST_HELP: {
    BASE: REQUEST_HELP_BASE,
  },
  MARKETING_ATTRIBUTION: {
    BASE: MARKETING_ATTRIBUTION_BASE,
    GET_ATTRIBUTION_SALES_DATA: `${MARKETING_ATTRIBUTION_BASE}/get-attribution-sales-data`,
  },
};

/** Full URLs for mocks/tests — same keys as API_URLS, with BASE_URL prepended. */
export const API_FULL_URLS = buildFullUrls(API_URLS, BASE_URL);
